/**
 * =============================================================================
 * names.js — GENERATOR NAMA SEMUT
 * =============================================================================
 * Menyediakan nama default (Ant 1, Ant 2, ...) dan nama acak lucu.
 * Dipakai di menu (random nama / create participant).
 * =============================================================================
 */

import { pick, randInt } from './config.js';

/* Prefiks nama gabungan, contoh: "Speedy ..." */
const PREFIXES = [
  'Tiny', 'Speedy', 'Mighty', 'Lucky', 'Fuzzy', 'Brave', 'Sneaky', 'Turbo',
  'Chill', 'Spicy', 'Cosmic', 'Pixel', 'Neon', 'Golden', 'Shadow', 'Sunny',
  'Bouncy', 'Zippy', 'Rusty', 'Pepper', 'Maple', 'Coco', 'Mango', 'Nitro',
  'Jazz', 'Nova', 'Blaze', 'Frost', 'Echo', 'Bolt', 'Daisy', 'Rocky',
];

/* Kata inti nama gabungan, contoh: "... Ant" */
const CORES = [
  'Ant', 'Crumb', 'Trail', 'Hill', 'Leaf', 'Twig', 'Pebble', 'Nectar',
  'Tunnel', 'Scout', 'Worker', 'Queen', 'Soldier', 'Drifter', 'Hopper',
  'Dash', 'Sprint', 'March', 'Crawl', 'Buzz', 'Pollen', 'Sprout', 'Moss',
  'Acorn', 'Berry', 'Clover', 'Petal', 'Dew', 'Ember', 'Spark',
];

/* Akhiran opsional (banyak string kosong = sering tanpa suffix) */
const SUFFIXES = [
  '', '', '', ' Jr', ' Sr', ' X', ' II', ' III', ' Prime', ' Max',
  ' Lite', ' Pro', ' Zero', ' One', ' Ace',
];

/* Nama lengkap lucu siap pakai (~28% peluang dipilih) */
const FUNNY = [
  'Sir Crumbs-a-Lot', 'Lady Mandible', 'Captain Antenna',
  'Professor Pincer', 'Duke Dusty', 'Baroness Bean',
  'General Giggle', 'Admiral Acorn', 'Count Cookie',
  'Dr. Doodle', 'Miss Maple', 'Chef Chewy',
  'Ninja Nibble', 'King Kibble', 'Queen Quirk',
  'Astro Antsy', 'Viking Vibes', 'Pirate Pebble',
  'Santa Sprinkle', 'Wizard Whisk', 'Hero Hops',
  'Cowboy Crumb', 'Police Pollen', 'Grad Grit',
  'Fairy Flake', 'Denim Dash', 'Hoodie Hop',
  'Hardhat Hank', 'Beats Betty', 'Specs Spike',
  'Mustache Max', 'Flower Flo', 'Crown Cruz',
  'Straw Sam', 'Winged Wisp', 'Royal Rolo',
];

/**
 * randomName(used)
 * ---------------------------------------------------------------------------
 * Buat nama unik.
 * @param {Set} used — kumpulan nama yang sudah dipakai (opsional)
 * @returns {string}
 */
export function randomName(used = new Set()) {
  let name = '';
  let tries = 0;
  do {
    if (Math.random() < 0.28) {
      /* Mode nama lucu siap pakai */
      name = pick(FUNNY);
    } else {
      /* Mode gabungan: Prefix + Core + Suffix (+ angka opsional) */
      name = `${pick(PREFIXES)} ${pick(CORES)}${pick(SUFFIXES)}`.trim();
      if (Math.random() < 0.15) name += ` ${randInt(1, 99)}`;
    }
    tries++;
  } while (used.has(name) && tries < 40);

  used.add(name);
  return name;
}

/**
 * defaultName(i)
 * Nama bawaan berurutan: Ant 1, Ant 2, ... (i zero-based).
 */
export function defaultName(i) {
  return `Ant ${i + 1}`;
}
